module.exports = __webpack_public_path__ + "img/ic_money.3dbfb2da.svg";